export const setting = {
  record_outgoing: {
    title: 'Record outgoing calls',
    warning_text: 'Call records are not available for your ',
    warning_link_text: 'PBX package',
    warning_text_end: ''
  },
  on_record: 'Enable recording?',
  off_record: 'Turn off recording?'
};
